import React from 'react';
import { motion } from 'framer-motion';
import { Award, Clock, FileText, Droplet, Search, Calendar } from 'lucide-react';
import { content } from '../data/content';
import { SunsetBands } from './SunsetBands';
const iconMap: Record<string, React.ElementType> = {
  award: Award,
  clock: Clock,
  'file-text': FileText,
  droplet: Droplet,
  search: Search,
  calendar: Calendar
};
export function WhyHatch() {
  return <section id="about" className="py-20 md:py-28 bg-brand-cream" data-id="element-259">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-260">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-261">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl font-bold text-brand-brown mb-6" data-id="element-262">
            {content.whyHatch.heading}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-brown/80" data-id="element-263">
            {content.whyHatch.intro}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-264">
          {content.whyHatch.benefits.map((benefit, index) => {
          const Icon = iconMap[benefit.icon];
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-lg overflow-hidden shadow-[0_8px_30px_rgb(63,22,16,0.08)] hover:shadow-[0_8px_30px_rgb(213,106,50,0.15)] transition-shadow duration-300 relative" data-id="element-265">
                <SunsetBands heights={['h-1', 'h-1', 'h-1', 'h-0']} className="absolute top-0 left-0 w-full" data-id="element-266" />
                <div className="p-8 pt-10" data-id="element-267">
                  <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center mb-6" data-id="element-268">
                    <Icon className="w-6 h-6 text-brand-orange" data-id="element-269" />
                  </div>
                  <h3 className="font-display text-xl font-bold text-brand-brown mb-3" data-id="element-270">
                    {benefit.title}
                  </h3>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}